module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visiable),
      expression: "visiable"
    }],
    staticClass: "formal-agent-complex-search"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.result,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入公司名称"
    },
    model: {
      value: (_vm.result.Customer),
      callback: function($$v) {
        _vm.$set(_vm.result, "Customer", $$v)
      },
      expression: "result.Customer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.result.C_Name),
      callback: function($$v) {
        _vm.$set(_vm.result, "C_Name", $$v)
      },
      expression: "result.C_Name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入联系电话"
    },
    model: {
      value: (_vm.result.Tel),
      callback: function($$v) {
        _vm.$set(_vm.result, "Tel", $$v)
      },
      expression: "result.Tel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "type": "success",
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default",
      "icon": "delete"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商ID",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入代理商编号"
    },
    model: {
      value: (_vm.result.Code),
      callback: function($$v) {
        _vm.$set(_vm.result, "Code", $$v)
      },
      expression: "result.Code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComShow),
      expression: "isComShow"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "代理商类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择代理商类型"
    },
    model: {
      value: (_vm.result.AgentTypeId),
      callback: function($$v) {
        _vm.$set(_vm.result, "AgentTypeId", $$v)
      },
      expression: "result.AgentTypeId"
    }
  }, _vm._l((_vm.agentTypeList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "value": index,
        "label": item.Value
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComShow),
      expression: "isComShow"
    }],
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属项目",
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.choiceProjectList),
      callback: function($$v) {
        _vm.choiceProjectList = $$v
      },
      expression: "choiceProjectList"
    }
  }, _vm._l((_vm.intentProjectList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComShow),
      expression: "isComShow"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('area-select', {
    ref: "areaForm",
    attrs: {
      "label": "意向区域",
      "label-width": "100px"
    },
    model: {
      value: (_vm.areaInfo),
      callback: function($$v) {
        _vm.areaInfo = $$v
      },
      expression: "areaInfo"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1312271c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMFormatAgent/components/complex-search/index.vue
// module id = 1387
// module chunks = 1